import React from "react";
import styled, {css} from "styled-components";
import {Farm} from "../../../contexts/Farms/types";
import {getBalanceNumber} from "../../../utils/formatBalance";
import BigNumber from "bignumber.js";
import {UnStake} from "./un_stake";
import {Reward} from "./reward";
import {FarmProvider} from "../../../contexts/farm_provider/farm_provider";
import Countdown from 'react-countdown';
import {AppConfig} from "../../../config";

export const StakeList: React.FC<{ listCell: Farm[] }> = (props) => {


    return (<Card>
        <CardTitle>My Portfolio</CardTitle>
        <StyleTitle>
            <p>Product</p>
            <p>Amount</p>
            <Hide>APY</Hide>
            <p>Rewards</p>
            <Hide>Pool Share</Hide>
            <Hide>Unlock In</Hide>
            <p>Initial</p>
            <p>Earnings</p>
        </StyleTitle>
        <>
            {
                props.listCell.length > 0 ? props.listCell.map((ev: Farm, j) => <StyleCell key={j}>
                    <p>{ev.name}</p>
                    <p> {getBalanceNumber(ev.tokenBalance.times(4)).toFixed()}</p>
                    <Hide>{ev.apy||0}%</Hide>
                    <p> {getBalanceNumber(ev.earning).toFixed(2)}</p>
                    <Hide>{(ev.tokenBalance.eq(0) || ev.totalSupply.eq(0) ? 0 : ev.tokenBalance.div(ev.totalSupply).toNumber()  * 100).toFixed(2)}%</Hide>
                    <Hide><Countdown
                        date={AppConfig.unlockIn}
                    /></Hide>
                    <p>
                        <FarmProvider model={ev}>
                            <UnStake/>
                            {/*<Reward/>*/}
                        </FarmProvider>
                    </p>
                    <p>
                        <FarmProvider model={ev}>
                            {/*<UnStake/>*/}
                            <Reward/>
                        </FarmProvider>
                    </p>
                </StyleCell>) : <NA>N/A
                </NA>
            }
        </>

    </Card>);
};


const CardTitle = styled.div`
height: 60px;
font-size: 24px;
font-weight: 400;
color: #FFFFFF;
line-height: 60px;
display: flex;
align-items: center;
${(ev) => Padding}
`;

export const Hide = styled.p`
 @media (max-width: 768px) {
    display:none !important;
  }
`;
const NA = styled.div`
text-align: center;
height:64px;
line-height:64px;
color: #fff;
`;

const StyleCell = styled.div`
${(ev) => Padding};

    height:64px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    >p{
        font-size: 15px;
        font-weight: 400;
        color: ${(props) => props.theme.color.whites[1001]};
        flex:1;
        
        //&:last-child{
        //    display:flex;
        //    flex: 2;
        //    justify-content: space-between;
        //}
      
        button{
            width:80%
        }
    }
    @media (max-width: 768px) {
     
        >p{
            font-size: 12px;
            &:last-child{
                width: 120px;
            }
        }
    }
`;

const StyleTitle = styled.div`
    display: flex;
    ${(ev) => Padding};
    justify-content: space-around;
    height:36px;
    align-items: center;
    background-color: rgba(32, 46, 83, 1);
    p{
        //&:last-child{
        //    padding-right:10px;
        //    flex: 2;
        //}
        flex:1;
        width: 30px;
        font-size: 14px;
        font-weight: 400;
        color: #8390B2;
        line-height: 36px;
    }
    
     @media (max-width: 768px) {
         >p{
            font-size:12px;
         }
     }
`;

const Card = styled.div`
  width: 100%;
  border: 1px solid rgba(39, 55, 97, 1);
  background-color: rgba(23, 37, 74, 1);
 
  border-radius: 10px;
`;


const Padding = css`
padding: 0 20px;
box-sizing: border-box;
  p{
      text-align: start;
        display: block;
        &:first-child{
        flex: 1.5;
        }
  }
`;
